import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const StepOne = ({ formData, onUpdate, onNext }) => {
  const [errors, setErrors] = useState({});

  const industryOptions = [
    { value: 'technology', label: 'Technology & Software' },
    { value: 'retail', label: 'Retail & E-commerce' },
    { value: 'healthcare', label: 'Healthcare & Medical' },
    { value: 'finance', label: 'Finance & Banking' },
    { value: 'manufacturing', label: 'Manufacturing' },
    { value: 'education', label: 'Education & Training' },
    { value: 'hospitality', label: 'Hospitality & Tourism' },
    { value: 'real-estate', label: 'Real Estate' },
    { value: 'consulting', label: 'Consulting & Services' },
    { value: 'other', label: 'Other' }
  ];

  const businessTypeOptions = [
    { value: 'service', label: 'Service-Based' },
    { value: 'product', label: 'Product-Based' },
    { value: 'hybrid', label: 'Hybrid (Service + Product)' }
  ];

  const revenueRangeOptions = [
    { value: '0-50k', label: '₹0 - ₹40 Lakhs' },
    { value: '50k-100k', label: '₹40 Lakhs - ₹80 Lakhs' },
    { value: '100k-500k', label: '₹80 Lakhs - ₹4 Crores' },
    { value: '500k-1m', label: '₹4 Crores - ₹8 Crores' },
    { value: '1m-5m', label: '₹8 Crores - ₹40 Crores' },
    { value: '5m+', label: '₹40 Crores+' }
  ];

  const primaryGoalOptions = [
    { value: 'growth', label: 'Growth - Increase revenue and market share' },
    { value: 'stability', label: 'Stability - Maintain consistent operations' },
    { value: 'expansion', label: 'Expansion - Enter new markets' },
    { value: 'funding', label: 'Funding - Raise capital for scaling' }
  ];

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.fullName?.trim()) {
      newErrors.fullName = 'Full name is required';
    }

    if (!formData?.mobileNumber?.trim()) {
      newErrors.mobileNumber = 'Mobile number is required';
    } else if (!/^\d{10}$/.test(formData.mobileNumber.replace(/\D/g, ''))) {
      newErrors.mobileNumber = 'Please enter a valid 10-digit mobile number';
    }

    if (!formData?.email?.trim()) {
      newErrors.email = 'Email address is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData?.companyName?.trim()) {
      newErrors.companyName = 'Company name is required';
    }

    if (!formData?.industry) {
      newErrors.industry = 'Please select your industry';
    }

    if (!formData?.businessType) {
      newErrors.businessType = 'Please select your business type';
    }

    if (!formData?.revenueRange) {
      newErrors.revenueRange = 'Please select your revenue range';
    }

    if (!formData?.primaryGoal) {
      newErrors.primaryGoal = 'Please select your primary goal';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onNext();
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Full Name"
          type="text"
          placeholder="Enter your full name"
          value={formData?.fullName || ''}
          onChange={(e) => onUpdate({ fullName: e?.target?.value })}
          error={errors?.fullName}
          required
        />

        <Input
          label="Mobile Number"
          type="tel"
          placeholder="Enter 10-digit mobile number"
          value={formData?.mobileNumber || ''}
          onChange={(e) => onUpdate({ mobileNumber: e.target.value })}
          error={errors?.mobileNumber}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Email Address"
          type="email"
          placeholder="Enter your email address"
          value={formData?.email || ''}
          onChange={(e) => onUpdate({ email: e.target.value })}
          error={errors?.email}
          required
        />

        <Input
          label="Company Name"
          type="text"
          placeholder="Enter your company name"
          value={formData?.companyName || ''}
          onChange={(e) => onUpdate({ companyName: e?.target?.value })}
          error={errors?.companyName}
          required
        />
      </div>

      <Input
        label="Website (Optional)"
        type="url"
        placeholder="https://www.yourcompany.com"
        value={formData?.website || ''}
        onChange={(e) => onUpdate({ website: e?.target?.value })}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Industry"
          placeholder="Select your industry"
          options={industryOptions}
          value={formData?.industry || ''}
          onChange={(value) => onUpdate({ industry: value })}
          error={errors?.industry}
          required
          searchable
        />

        <Select
          label="Business Type"
          placeholder="Select business type"
          options={businessTypeOptions}
          value={formData?.businessType || ''}
          onChange={(value) => onUpdate({ businessType: value })}
          error={errors?.businessType}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Annual Revenue Range"
          placeholder="Select revenue range"
          options={revenueRangeOptions}
          value={formData?.revenueRange || ''}
          onChange={(value) => onUpdate({ revenueRange: value })}
          error={errors?.revenueRange}
          required
        />

        <Select
          label="Primary Business Goal"
          placeholder="Select your primary goal"
          options={primaryGoalOptions}
          value={formData?.primaryGoal || ''}
          onChange={(value) => onUpdate({ primaryGoal: value })}
          error={errors?.primaryGoal}
          required
        />
      </div>

      <div className="flex justify-end pt-4">
        <Button
          type="submit"
          variant="default"
          size="lg"
          iconName="ArrowRight"
          iconPosition="right"
        >
          Continue to Step 2
        </Button>
      </div>
    </form>
  );
};

export default StepOne;